import { useApiRequest } from '@/lib/http-utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'
import {
  ServiceRegistryCreateUpdateAPIResponse,
  ServiceRegistryCreateUpdateParams,
  transformParamsToRequestBody,
} from './use-create-service-registry-mutation'

export function useEditServiceRegistryMutation({ serviceId }: { serviceId: string }) {
  const { apiRequest, domainId } = useApiRequest()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      params: ServiceRegistryCreateUpdateParams,
    ): Promise<ServiceRegistryCreateUpdateAPIResponse> => {
      const requestBody = transformParamsToRequestBody(params)
      const response = await apiRequest({
        path: taskManagerApiPaths.mcpUpdate({ domainId, serviceId }),
        options: {
          method: 'PATCH',
          body: requestBody,
        },
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_UPDATE_SERVICE_REGISTRY')
      }

      const data = (await response.json()) as ServiceRegistryCreateUpdateAPIResponse

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['service-registry', domainId] })
    },
  })
}
